import { categories } from "@/mocks/comics";

const colorMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-700",
  secondary: "bg-secondary-100 text-secondary-800",
};

export default function Categories() {
  return (
    <section id="category" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-sm font-semibold text-secondary-800">
              <i className="ri-grid-fill"></i> 题材分类
            </span>
            <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">按题材快速找到你的菜</h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
              热血、古风、科幻、悬疑、恋爱、治愈……丰富题材一网打尽，人气连载随时开追。
            </p>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href="#top"
              className="manga-card-hover group flex items-center gap-4 rounded-2xl bg-background-50 p-5"
            >
              <span
                className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl ${colorMap[cat.color]}`}
              >
                <i className={`${cat.icon} text-xl`}></i>
              </span>
              <div className="min-w-0 flex-1">
                <h3 className="text-base font-bold text-foreground-950 group-hover:text-primary-600">{cat.name}</h3>
                <p className="mt-0.5 text-xs text-foreground-500">{cat.count} 部连载</p>
              </div>
              <i className="ri-arrow-right-line text-foreground-300 transition-transform group-hover:translate-x-1 group-hover:text-primary-500"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}